import BaseTable from "../BaseTable/BaseTable";
import { routeData } from "~/routes/market";
import { useRouteData } from "solid-start";
import { Expires } from "../Expires/Expires";
import fetchBaseUrl from "~/utils/fetchBaseUrl";

interface IDsTableProps { }

const IDsTable = (props: IDsTableProps) => {
  const tableHeaders = ["ID", "Price", "Expiry Date"];
  const itemsPerPage = 100;
  const tableTabs = [
    {
      listings: <button class="mr-20">Listings</button>,
    },
    {
      offers: <button class="mr-20">Offers</button>,
    },
  ];
  const handleClick = (iaddr: string) => {
    window.location = `${fetchBaseUrl()}/idlookup/${iaddr}` as any;
  };
  const { id_data } = useRouteData<typeof routeData>();

  if (!id_data()) return <></>;

  const { ids, offers, blockheight } = id_data() as any;
  console.log(ids);

  const mappedListings = ids.map((id: any) => {
    const { name, price, blockexpiry } = id;

    return {
      data: {
        name,
        price,
        expiry: blockexpiry,
        blockheight,
      },
      markup: [
        <div
          onClick={() => handleClick(id.id_iaddr)}
          class="hover:cursor-pointer"
        >
          {name}
        </div>,
        <div
          onClick={() => handleClick(id.id_iaddr)}
          class="flex items-baseline gap-x-3 hover:cursor-pointer"
        >
          <span>{price}</span>
          <span class="text-base font-bold text-link-color">VRSC</span>
        </div>,
        <div
          onClick={() => handleClick(id.id_iaddr)}
          class="hover:cursor-pointer"
        >
          <Expires blockheight={blockheight} expires={blockexpiry} />
        </div>,
      ],
    };
  });

  const mappedOffers = offers.map((id: any) => {
    const { name, price, blockexpiry } = id;

    return {
      data: {
        name,
        price,
        expiry: blockexpiry,
        blockheight,
      },
      markup: [
        <div
          onClick={() => handleClick(id.id_iaddr)}
          class="hover:cursor-pointer"
        >
          {name}
        </div>,
        <div
          onClick={() => handleClick(id.id_iaddr)}
          class="flex items-baseline gap-x-3 hover:cursor-pointer"
        >
          <span>{price}</span>
          <span class="text-base font-bold text-link-color">VRSC</span>
        </div>,
        <div
          onClick={() => handleClick(id.id_iaddr)}
          class="hover:cursor-pointer"
        >
          <Expires blockheight={blockheight} expires={blockexpiry} />
        </div>,
      ],
    };
  });

  return (
    <div class="w-full lg:w-[60%] relative px-10 lg:mx-20">
      <BaseTable
        mobileTableHeaders={['price', 'expiry']}
        sortFields={{
          listings: ["price", "expiry"],
          offers: ["price", "expiry"],
        }}
        searchParams={{
          listings: ["name"],
          offers: ["name"],
        }}
        tableHeaders={tableHeaders}
        tableTabs={tableTabs}
        tableRows={{
          listings: mappedListings,
          offers: mappedOffers,
        }}
      />
    </div>
  );
};
export default IDsTable;
